//时间戳转换成时间格式

export function getMyDate(str) {
    var date;
    // 如果是日期字符串(YYYY-MM-DD格式),手动解析避免时区问题
    if (typeof str === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(str)) {
        const [year, month, day] = str.split('-');
        // 使用斜杠格式,这样在所有浏览器中都会被解析为本地时间
        date = new Date(year + '/' + month + '/' + day + ' 00:00:00');
    } else {
        date = new Date(str);
    }
    let oYear = date.getFullYear(); //年
    let oMonth = date.getMonth() + 1; //月
    let oDay = date.getDate(); //日
    let h = date.getHours(); //小时
    let m = date.getMinutes(); //分钟
    let s = date.getSeconds(); //秒数
    // 以自己需要的方式拼
    var oTime = oYear + '-' + getZero(oMonth) + '-' + getZero(oDay) + ' ' + getZero(h) + ':' + getZero(m) +
        ':' + getZero(s); //最后拼接时间
    return oTime;
}

//获取时间精确到分钟
export function getDateToMin(str) {
    var date;
    // 如果是日期字符串(YYYY-MM-DD格式),手动解析避免时区问题
    if (typeof str === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(str)) {
        const [year, month, day] = str.split('-');
        // 使用斜杠格式,这样在所有浏览器中都会被解析为本地时间
        date = new Date(year + '/' + month + '/' + day + ' 00:00:00');
    } else {
        date = new Date(str);
    }
    let oYear = date.getFullYear(); //年
    let oMonth = date.getMonth() + 1; //月
    let oDay = date.getDate(); //日
    let h = date.getHours(); //小时
    let m = date.getMinutes(); //分钟
    // 以自己需要的方式拼
    var oTime = oYear + '-' + getZero(oMonth) + '-' + getZero(oDay) + ' ' + getZero(h) + ':' + getZero(m); //最后拼接时间
    return oTime;
}
function getZero(num) {
    // 单数前面加0
    if (parseInt(num) < 10) {
        num = '0' + num;
    }
    return num;
}

export function getcurrentDate(str) {
    // 输入的日期字符串
    let dateString = str;

    // 使用 "-" 分割字符串得到年、月、日的数组
    let dateArray = dateString.split("-");

    // 分别获取年、月、日
    let year = parseInt(dateArray[0]);
    let month = parseInt(dateArray[1]) - 1;
    let day = parseInt(dateArray[2]);
    return new Date(year, month, day);
}

export function getcurrentDateTime(str) {
    // 输入的日期字符串
    let dateString = str;
    console.log(str)

    // 使用 "-" 分割字符串得到年、月、日的数组
    // let dateArray = dateString.split("-");
    //
    // // 分别获取年、月、日
    // let year = parseInt(dateArray[0]);
    // let month = parseInt(dateArray[1]) - 1;
    // let day = parseInt(dateArray[2]);
    return new Date(dateString);
}
